// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1706":"53ae1d82","3252":"8afebb90","3924":"974206c0","5703":"0f25b3bb"}[chunkId] + ".chunk.css";
};